"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var originalLoadjs = require("loadjs");
var loadjs = originalLoadjs;
function mockLoadjs(mockedLoadjs) {
    loadjs = mockedLoadjs || originalLoadjs;
}
exports.mockLoadjs = mockLoadjs;
var stack = {};
var loadSDK = function (name, url, onLoaded, onError, onReady) {
    loadjs(url, {
        success: function () {
            if (onReady) {
                var previousOnReady_1 = window[onReady];
                window[onReady] = function () {
                    if (previousOnReady_1) {
                        previousOnReady_1();
                    }
                    onLoaded(window[name]);
                };
            }
            else {
                onLoaded(window[name]);
            }
        },
        error: function (err) {
            onError(err);
        },
    });
};
var requireSDK = function (name, url, onLoaded, onError, resolveRequire) {
    window.require([url], function (sdk) {
        window[name] = resolveRequire(sdk);
        onLoaded(window[name]);
    }, function (err) {
        onError(err);
    });
};
function getSDK(_a) {
    var name = _a.name, url = _a.url, onReady = _a.onReady, _b = _a.isLoaded, isLoaded = _b === void 0 ? function () { return true; } : _b, _c = _a.resolveRequire, resolveRequire = _c === void 0 ? function (sdk) { return sdk; } : _c, isRequireAllow = _a.isRequireAllow;
    if (window[name] && isLoaded(window[name])) {
        return Promise.resolve(window[name]);
    }
    return new Promise(function (resolve, reject) {
        if (stack[url]) {
            stack[url].push(resolve);
            return;
        }
        stack[url] = [resolve];
        var onLoaded = function (sdk) {
            stack[url].forEach(function (resolveItem) { return resolveItem(sdk); });
        };
        if (isRequireAllow &&
            typeof window.require === 'function' &&
            typeof window.define === 'function' &&
            window.define.amd) {
            requireSDK(name, url, onLoaded, reject, resolveRequire);
        }
        else {
            loadSDK(name, url, onLoaded, reject, onReady);
        }
    });
}
exports.getSDK = getSDK;
//# sourceMappingURL=getSDK.js.map